export enum I18nEntityType {
  Unknow = 0,
  SharedList = 1,
  Schema = 2,
  Profil = 3,
  Form = 4,
  Global = 255,
}
